<template>
	<el-dialog
		:visible.sync="isProcessRecordDialog"
		:close-on-click-modal="false"
		v-if="isProcessRecordDialog"
		width="80%"
	>
		<ProcessRecord
			:instId="instId"
			:taskId="taskId"
			:referOpinion="referOpinion"
			:nodeType="nodeType"
			:defId="defId"
			:nodeId="nodeId"
		/>
	</el-dialog>
</template>

<script>
import ProcessRecord from '@/components/flow/processRecord.vue';
export default {
	name: 'processRecordDialog',
	props: ['instId', 'taskId', 'referOpinion', 'nodeType', 'defId', 'nodeId'],
	components: { ProcessRecord },
	data() {
		return {
			isProcessRecordDialog: false,
		};
	},
	methods: {
		handleClose(done) {
			this.isProcessRecordDialog = true;
		},
	},
};
</script>

<style lang="scss" scoped></style>
